var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuarderiaMascotas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GuarderiaMascotas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217.847,
    height: 273.706,
    viewBox: "0 0 217.847 273.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7A4666;\n        stroke: #7A4666;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-1",
    width: 217.847,
    height: 273.706
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M216.333,93.737l-20.6-38.883a25.332,25.332,0,0,0-22.435-13.5h-56.81V17.947a17.947,17.947,0,0,0-35.895,0V41.359H10.827A10.839,10.839,0,0,0,0,52.183v96.832a10.837,10.837,0,0,0,10.827,10.824H80.591v82.138H36.759A8.772,8.772,0,0,0,28,250.74v14.207a8.774,8.774,0,0,0,8.762,8.762H160.317a8.776,8.776,0,0,0,8.762-8.762V250.74a8.774,8.774,0,0,0-8.762-8.762H116.486V159.839h56.643a25.284,25.284,0,0,0,22.578-13.779l20.706-40.279a13.031,13.031,0,0,0-.078-12.044M91.782,17.947a6.756,6.756,0,0,1,13.513,0V41.359H91.782Zm22.275,235.221h43.832v9.35H39.188v-9.35H83.019a8.774,8.774,0,0,0,8.762-8.762V159.839h13.513v84.567a8.772,8.772,0,0,0,8.762,8.762m92.4-152.5-20.7,40.276a14.147,14.147,0,0,1-12.629,7.7H11.191v-96.1H173.3A14.162,14.162,0,0,1,185.841,60.1l20.6,38.88a1.822,1.822,0,0,1,.014,1.69",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M44.339,42.93a8.5,8.5,0,0,0,8.5-8.5V30.175a8.5,8.5,0,0,0-17,0v4.253a8.5,8.5,0,0,0,8.5,8.5",
    transform: "translate(64.425 38.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M35.221,42.93a8.5,8.5,0,0,0,8.5-8.5V30.175a8.5,8.5,0,0,0-17,0v4.253a8.5,8.5,0,0,0,8.5,8.5",
    transform: "translate(48.033 38.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M50.417,29.271a8.5,8.5,0,0,0-8.5,8.5v4.253a8.5,8.5,0,1,0,17,0V37.773a8.5,8.5,0,0,0-8.5-8.5",
    transform: "translate(75.351 52.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-1",
    d: "M37.646,42.026V37.773a8.5,8.5,0,1,0-17,0v4.253a8.5,8.5,0,0,0,17,0",
    transform: "translate(37.107 52.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M62.406,37.723h0a12.628,12.628,0,0,0-20.1,0l-15.449,20.3A12.628,12.628,0,0,0,36.908,78.3h30.9A12.624,12.624,0,0,0,77.853,58.029Z",
    transform: "translate(43.652 58.858)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarderiaMascotas);
export default __webpack_public_path__ + "static/media/GuarderiaMascotas.acedfed2449ad838a69b9668abf474c1.svg";
export { ForwardRef as ReactComponent };